import React from 'react';
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";

import css from './SingleOrdersInfoPackModal.module.css';
import {ButtonUpdate, ImageReusable} from "../../../../ui";
import {sampleMenuActions} from "../../../../store/slices/menu-slices";


const SingleOrdersInfoPackModal = ({
                                       setIsShowSingleDish,
                                       dish,
                                       setSelectedDishId,
                                       setIsShowUpdateSingleDish,
                                       idMatching,
                                       mealI,
                                       singlePackId
                                   }) => {
    const {i18n} = useTranslation();
    const {id, name, img, weight, energy} = dish;
    const dispatch = useDispatch();

    const currentLanguage = i18n.language;
    const displayName = name?.[currentLanguage] || name?.["en"] || "Unknown Dish";


    const handleUpdate = (e) => {
        e.preventDefault();
        e.stopPropagation();

        dispatch(sampleMenuActions.changeIdForMeal(mealI));
        dispatch(sampleMenuActions.changeId(singlePackId));

        if (idMatching) {
            dispatch(sampleMenuActions.changeIdMatching(idMatching));
            dispatch(sampleMenuActions.changeTrigger());
        }

        setIsShowUpdateSingleDish(true);
    };

    const showSingleDish = () => {
        setIsShowSingleDish(true);
        setSelectedDishId(id);
    };


    return (
        <div className={css.wrap} onClick={showSingleDish}>
            <div className={css.imgBlock}>
                <ImageReusable src={img} className={css.imageTag} alt="Food Image"/>
            </div>
            <div>{displayName}</div>
            <div>{weight}g/{energy}kcal</div>
            <div>
                <ButtonUpdate onClick={handleUpdate}/>
            </div>
        </div>
    );
};

export {SingleOrdersInfoPackModal};
